import React from 'react';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import { connect } from 'react-redux';
import _ from 'lodash';
import eventify from 'Eventify';
let findIndicidents = (event, types, name) => {
    return [
        ..._.chain(event.incidents)
            .filter(i => types.indexOf(i.subtype) !== -1)
            .sortBy(i => -i.min)
            .map(incident => ({
                name,
                groupTitle: `${incident.min}min`,
                groupKey: `${incident.incidentId}`,
                props: {
                    eventId: event.eventId,
                    incidentId: incident.incidentId
                }
            }))
    ];
};

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    render() {
        let { event } = this.props;

        if (eventify(event).isComing()) {
            return <h3 style={{ textAlign: 'center' }}>Match is not started</h3>;
        }

        return (
            <div>
                <SMStream smWidgets={findIndicidents(event, ['goal', 'goal_own'], 'IncidentWidget')} title="Goals" />
                <SMStream smWidgets={findIndicidents(event, ['card'], 'IncidentWidget')} title="Cards" />
                <SMStream smWidgets={findIndicidents(event, ['subst_in'], 'IncidentWidget')} title="Substitutions" />
                <SMStream
                    smWidgets={findIndicidents(event, ['goal', 'goal_own'], 'AnimatedGoal')}
                    title="Animated Goals v1"
                />
                <SMStream
                    smWidgets={findIndicidents(event, ['goal', 'goal_own'], 'AnimatedIncident')}
                    title="Animated Goals v2"
                />

                <SMStream smWidgets={findIndicidents(event, ['card'], 'AnimatedIncident')} title="Animated Cards v2" />
            </div>
        );
    }
}

export default connect(state => ({ ...state.smBrowser }))(EventSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventIncidentsSMB.js
 **/